<template>
  <!-- <pre class="text-black">{{ props.card?.mediaField?.data }}</pre> -->
  <div class="dialog-card" :style="[
     CssStyleHelpers.blur(cardsGroup.blur, cardsGroup.isBlurShown),
      CssStyleHelpers.background(
            cardsGroup.backgroundColor,
            cardsGroup.isBackgroundShown
          ),
  ]">
    <!-- Карточка с контентом -->
    <div
      class="dialog-card-content flex"
      :style="[
        CssStyleHelpers.flexDirection(props.card.gridReverse),
        CssStyleHelpers.alignItems(props.cardsGroup.mediaAlign || 'center'),
      ]"
    >
      <!-- <pre class="text-black">
      card: {{ card }}
    </pre
      > -->
      <!-- Медиа секция -->

      <div
        v-if="cardsGroup.showMedia"
        class="dialog-card-media overflow-hidden aspect-ratio-1/1 flex-shrink-0 z-10"
        :style="[
          CssStyleHelpers.borderRadius(
            props.card?.mediaField?.data?.url 
              ? cardsGroup.mediaBorderRadius 
              : 50, 
            '%'
          ),
           StyleUtils.size(cardsGroup.mediaSize, { unit: 'px', coefficient: 1 }),
           StyleUtils.marginsFromImageSize(
             props.card.gridReverse ? { left: props.cardsGroup.mediaGap } : { right: props.cardsGroup.mediaGap },
             cardsGroup.mediaSize
           )
         
        ]"
      >
        <MediaCard
          v-if="props.card?.mediaField?.data?.url || props.card?.mediaField?.data?.previewUrl"
          :media-type="props.card?.mediaField?.type"
          :image-props="CssImageHelpers.imageProps(props.card?.mediaField?.data)"
          :video-props="CssVideoHelpers.videoProps(props.card?.mediaField?.data)"
          :mask-props="props.cardsGroup?.maskProps"
          :object-fit="props.card?.mediaField?.data?.objectFit || 'contain'"
          :border-radius="props.card?.mediaField?.data?.borderRadius"
          :aspect-ratio="1"
          :style="[
          ]"
        />
        <div v-else>
          </div>
      </div>

       <!-- Текстовая секция -->
       <div
         v-if="props.cardsGroup?.showText"
         class="dialog-card-text"
         :style="[
           CssStyleHelpers.background(
             cardsGroup.contentBackgroundColor,
             cardsGroup.isContentBackgroundShown
           ),
           CssStyleHelpers.paddings({
            ...props.innerSpacing,
            left: !props.card.gridReverse ? (props.innerSpacing?.left ?? 0) : (props.innerSpacing?.right ?? 0),
            right: !props.card.gridReverse ? (props.innerSpacing?.right ?? 0) : (props.innerSpacing?.left ?? 0),
           }),
           CssStyleHelpers.borderRadius(cardsGroup.cardBorderRadius),
           CssStyleHelpers.border(props.card.borderField?.data, props.card.borderField?.data?.enabled),
         ]"
       >
        <TextCard :text="props.card?.textField?.data?.text" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PropType } from "vue";
import MediaCard from "./MediaCard.vue";
import TextCard from "./TextCard.vue";
import {
  CssStyleHelpers,
  CssImageHelpers,
  CssVideoHelpers,
  StyleUtils,
} from "../utils/cssStyleHelpers";


const props = withDefaults(defineProps<{
  card: any;
  cardsGroup: any;
  innerSpacing?: any;
}>(), {
  innerSpacing: () => ({ top: 0, right: 0, bottom: 0, left: 0 })
});

</script>

<style scoped>
@reference "tailwindcss";
.dialog-card {
  @apply w-full h-full overflow-hidden;
}

.dialog-card-content {
  /* @apply w-full h-full overflow-hidden; */
}

.dialog-card-media {
  /* @apply min-w-[100px] min-h-full overflow-hidden; */
  /* border: 1px solid black; */
}

.dialog-card-media.has-media {
  border: none;
}

.dialog-card-text {
  @apply text-base leading-relaxed;
  height: fit-content;
  display: inline-flex;
  width: fit-content;
  max-width: 80%;
}

/* Адаптивность для мобильных устройств */
@media (max-width: 768px) {
  .dialog-card-text {
    @apply text-sm;
    max-width: 100%;
  }

  /* .dialog-card-media {
    height: 45% !important;
    margin-bottom: 0.75rem;
  } */
}
</style>
